/**
 * Registration Data API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ErrorResponseDto } from '../model/error-response';
// @ts-ignore
import { PartnerShareholdingResponseDto } from '../model/partner-shareholding-response';
// @ts-ignore
import { PartnersRegistrationDataRequestDto } from '../model/partners-registration-data-request';
// @ts-ignore
import { PartnersRegistrationDataResponseDto } from '../model/partners-registration-data-response';
// @ts-ignore
import { PartnersShareholdingRequestDto } from '../model/partners-shareholding-request';
// @ts-ignore
import { RegistrationAttributeResponseDto } from '../model/registration-attribute-response';
// @ts-ignore
import { RegistryTypeDto } from '../model/registry-type';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    RegistrationDataServiceInterface,
    GetPartnersRegistrationDataRequestParams,
    GetPartnersShareholdingRequestParams,
    GetRegistrationDataRequestParams
} from './registration-data.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class RegistrationDataService extends BaseService implements RegistrationDataServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Returns detailed registration data (integrated with DeLorean) of the partners.
     * @endpoint post /v1/alert/registration-data/partners
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPartnersRegistrationData(requestParameters: GetPartnersRegistrationDataRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<PartnersRegistrationDataResponseDto>>;
    public getPartnersRegistrationData(requestParameters: GetPartnersRegistrationDataRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<PartnersRegistrationDataResponseDto>>>;
    public getPartnersRegistrationData(requestParameters: GetPartnersRegistrationDataRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<PartnersRegistrationDataResponseDto>>>;
    public getPartnersRegistrationData(requestParameters: GetPartnersRegistrationDataRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const partnersRegistrationDataRequestDto = requestParameters?.partnersRegistrationDataRequestDto;
        if (partnersRegistrationDataRequestDto === null || partnersRegistrationDataRequestDto === undefined) {
            throw new Error('Required parameter partnersRegistrationDataRequestDto was null or undefined when calling getPartnersRegistrationData.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/alert/registration-data/partners`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<PartnersRegistrationDataResponseDto>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: partnersRegistrationDataRequestDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve shareholding percentage for multiple partners
     * @endpoint post /v1/alert/registration-data/partners/shareholding
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPartnersShareholding(requestParameters: GetPartnersShareholdingRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<PartnerShareholdingResponseDto>>;
    public getPartnersShareholding(requestParameters: GetPartnersShareholdingRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<PartnerShareholdingResponseDto>>>;
    public getPartnersShareholding(requestParameters: GetPartnersShareholdingRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<PartnerShareholdingResponseDto>>>;
    public getPartnersShareholding(requestParameters: GetPartnersShareholdingRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const partnersShareholdingRequestDto = requestParameters?.partnersShareholdingRequestDto;
        if (partnersShareholdingRequestDto === null || partnersShareholdingRequestDto === undefined) {
            throw new Error('Required parameter partnersShareholdingRequestDto was null or undefined when calling getPartnersShareholding.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/alert/registration-data/partners/shareholding`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<PartnerShareholdingResponseDto>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: partnersShareholdingRequestDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retorna dados cadastrais detalhados (integrado ao Delorean)
     * @endpoint get /v1/alert/registration-data/{registryId}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getRegistrationData(requestParameters: GetRegistrationDataRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<RegistrationAttributeResponseDto>>;
    public getRegistrationData(requestParameters: GetRegistrationDataRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<RegistrationAttributeResponseDto>>>;
    public getRegistrationData(requestParameters: GetRegistrationDataRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<RegistrationAttributeResponseDto>>>;
    public getRegistrationData(requestParameters: GetRegistrationDataRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const registryId = requestParameters?.registryId;
        if (registryId === null || registryId === undefined) {
            throw new Error('Required parameter registryId was null or undefined when calling getRegistrationData.');
        }
        const type = requestParameters?.type;
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling getRegistrationData.');
        }
        const walletId = requestParameters?.walletId;
        if (walletId === null || walletId === undefined) {
            throw new Error('Required parameter walletId was null or undefined when calling getRegistrationData.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'type',
            <any>type,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'walletId',
            <any>walletId,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/alert/registration-data/${this.configuration.encodeParam({name: "registryId", value: registryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<RegistrationAttributeResponseDto>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
